import { CountryOption } from "../localizedTypes";

export interface CountryCodeItemProps {
  country: CountryOption;
  close: (ref?: HTMLElement) => void;
  handleSelect: (newLocale: CountryOption) => void;
}

export const CountryCodeItem = ({
  country,
  close,
  handleSelect,
}: CountryCodeItemProps) => {
  const CountryFlag = () => country.flag;
  const displayText = `${country.countryName} (${country.countryCode})`;
  return (
    <div
      onClick={() => {
        handleSelect(country);
        close();
      }}
      className="bg-white h-[43px] rounded-[4px] items-center flex gap-[6px] px-4 py-1 hover:bg-[#F3F4F6] cursor-pointer"
    >
      <CountryFlag />
      <span className="text-nowrap">{displayText}</span>
    </div>
  );
};
